import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const LogIn = () => {
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showPassword, setShowPassword] = useState(false);
  let navigate = useNavigate();

  const [formData, setFormData] = useState({
    userId: "",
    password: "",
  });
  const [schoolData, setSchoolData] = useState([]);

  const fetchSchoolDetails = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');

      const response = await fetch(`${apiUrl}/FeeReport/GetSchoolName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }
      const data = await response.json();
      setSchoolData(data);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   fetchSchoolDetails();
  // }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

const fetchTeacherDetails = async (classId, sectionId) => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem('token');
    const response = await fetch(
      `${apiUrl}/CreateClass/FillClassSectionDetails?Id=${classId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}), // Empty body or omit if not needed
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch teacher details: ${response.status}`);
    }
    const data = await response.json();
    const section = data.find((s) => s.sectionId === sectionId);
    if (section) {
      sessionStorage.setItem('teacherId', section.teacherId);
      sessionStorage.setItem('teacherName', section.teacherName);
      console.log("Teacher ID set:", section.teacherId); // Debug log
    } else {
      console.warn("Teacher not found for the given section.");
    }
  } catch (error) {
    console.error("Error fetching teacher details:", error);
  }
};
 const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handlelogIn = async (e) => {
  e.preventDefault(); // Prevent the default form submission behavior
setLoading(true); // ← ADD
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const response = await fetch(`${apiUrl}/UserLogin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": sessionStorage.getItem('token1')
},
      body: JSON.stringify({
        userId: formData.userId,
        password: formData.password,
      }),
    });

    if (response.ok) {
// Login successful, navigate to the dashboard page or perform any other necessary actions
      const responseData = await response.json();
      const { token } = responseData;
      const { lastLoginOn } = responseData;
      const { leftDays } = responseData.objOutput;
      sessionStorage.setItem('login', true);
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('lastLoginOn', lastLoginOn);
      sessionStorage.setItem('leftday', leftDays);


     if (typeof responseData.objOutput === 'object' && responseData.objOutput !== null) {
      // Save objOutput and token to session storage
        sessionStorage.setItem('objOutput', JSON.stringify(responseData.objOutput));
        sessionStorage.setItem('userId', JSON.stringify(responseData.objOutput.userId))
        sessionStorage.setItem('classId', JSON.stringify(responseData.objOutput.classId))
        sessionStorage.setItem('sectionId', JSON.stringify(responseData.objOutput.sectionId))
        sessionStorage.setItem('employeeId', JSON.stringify(responseData.objOutput.employeeId))
        sessionStorage.setItem('userGroupId', JSON.stringify(responseData.objOutput.userGrpId))
        sessionStorage.setItem('userType', JSON.stringify(responseData.objOutput.userType))
        sessionStorage.setItem('organizationName', JSON.stringify(responseData.objOutput.organizationName))
        sessionStorage.setItem('logo', JSON.stringify(responseData.objOutput.logo))
        sessionStorage.setItem('clientImage', JSON.stringify(responseData.objOutput.imageUrl))
        sessionStorage.setItem('clientName', JSON.stringify(responseData.objOutput.employeeName))
        sessionStorage.setItem('expirydate', JSON.stringify(responseData.objOutput.expiryDate))
          sessionStorage.setItem('branchId', JSON.stringify(responseData.objOutput.branchId));
          sessionStorage.setItem('is_Master', JSON.stringify(responseData.objOutput.is_Master));

                  sessionStorage.setItem('branchName', JSON.stringify(responseData.objOutput.branchName));


      } else {
        console.error('Invalid objOutput:', responseData.objOutput);
      }

           // Fetch school details AFTER login token is set
      await fetchSchoolDetails();

 if (responseData.objOutput.userType === "Parent" && responseData.objOutput.userGrpId === 7) {
        const classId = responseData.objOutput.classId;
        const sectionId = responseData.objOutput.sectionId;
        if (classId && sectionId) {
          await fetchTeacherDetails(classId, sectionId);
        }
      }

       // Determine the redirect URL based on userType
      let redirectUrl = "/dashboard"; // Default to employee dashboard
      if (responseData.objOutput.userType === "Student") {
        redirectUrl = "/studentdashboard";
      } else if (responseData.objOutput.userType === "Employee" && responseData.objOutput.userGrpId === 5) {
        redirectUrl = "/teachersdashboard";
      } else if (responseData.objOutput.userType === "Parent" && responseData.objOutput.userGrpId === 7) {
        redirectUrl = "/ParentDashboard";
      }
        

        // Redirect the user
           navigate(redirectUrl);
   } else {
      // Handle login failure here — show the actual server message
      let errorMessage = 'Invalid credentials';
      try {
        const errorData = await response.json();
        if (errorData.msg) {
          errorMessage = errorData.msg;
        }
      } catch (parseError) {
        console.error("Failed to parse error response:", parseError);
      }

      console.error("Login failed:", errorMessage);
      setSnackbarMessage(errorMessage);
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  } catch (error) {
    // Handle API request error here
    console.error("API request error:", error);
     // alert('An error occurred. Please try again later.');
    setSnackbarMessage('An error occurred. Please try again later.');
    setOpenSnackbar(true);
    setSnackbarSeverity("error");
  }
  finally {
    setLoading(false); // ← ADD
  }
};

  const logo = sessionStorage.getItem('clientLogo');
  const name = sessionStorage.getItem('clientCode');

  return (
  <div className="home">
      <main className="login-body" data-vide-bg="assets/img/login-bg.mp4">
        <form className="form-default" onSubmit={handlelogIn}>
          <div className="login-form">

            <div className="logo-login">
              <img src={`https://wsmsv1.aidigitalsec.com${logo.replace('~', '')}`} alt="Logo" />
            </div>
            <h2>Login : {name}</h2>
            <div className="form-input">
              <label htmlFor="name">User Name</label>
              <input
                type="text"
                name="userId"  // Make sure the name attribute is set to "userId"
                placeholder="Username"
                onChange={handleInputChange}
                value={formData.userId}
              />
            </div>
           <div className="form-input" style={{ position: 'relative' }}>
              <label htmlFor="password">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                onChange={handleInputChange}
                value={formData.password}
                style={{ paddingRight: '40px' }}
              />
              <IconButton
                onClick={handleTogglePasswordVisibility}
                edge="end"
                style={{
                  position: 'absolute',
                  right: '5px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  marginTop: '12px'
                }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>
            <div className="form-input pt-30" style={{ position: 'relative' }}>
  <input type="submit" name="submit" value={loading ? '' : 'Login'} disabled={loading} />
  {loading && (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      pointerEvents: 'none',
      color: '#000000',
      fontSize: '14px',
    }}>
      <CircularProgress size={16} style={{ color: '#000000' }} />
      Logging in...
    </div>
  )}
</div>

          </div>
        </form>
      </main>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};


export default LogIn